import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CILsTable from "../../components/CILs/CILsTable";




const CILsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="CILs" />

       {/* Projects Table */}
        <CILsTable />   

      </MasterLayout>
    </>
  );
};

export default CILsPage;
